import { useTranslation } from "react-i18next";
import AmazonLogo from "~/assets/svg/amazon-logo.svg?react";
import WorldBackgroundUrl from "~/assets/svg/world-background.svg?react";
import { Text } from "~/components/text";

export const SearchTermsAmazonEmpty = () => {
  const { t } = useTranslation(["searchTerms"]);
  return (
    <div className="h-96 relative bg-gray-50 rounded-xl outline outline-offset-[-0.50px] outline-gray-100 overflow-hidden p-9 flex justify-between md:flex-row flex-col">
      <div className="absolute right-0 top-0 z-0 opacity-50 md:opacity-100">
        <WorldBackgroundUrl />
      </div>
      <div className="z-2">
        <Text as="h2" variant="pageHeading">
          {t("searchTerms:searchTermsAmazonEmpty.title")}
        </Text>
        <Text variant="subtle" className="pt-2 w-md">
          {t("searchTerms:searchTermsAmazonEmpty.subtitle")}
        </Text>
        <Text variant="mutedItalic" className="pt-2 w-md">
          {t("searchTerms:searchTermsAmazonEmpty.teaser")}
        </Text>
      </div>
      <div className="-ml-6 -mb-1 z-3 md:-mt-1 md:-mr-8">
        <AmazonLogo />
      </div>
    </div>
  );
};
